import { n as e, s as t, t as ee } from "./editor-video-N3mI1ZWQ.js";
import { computed as n, createBlock as r, createCommentVNode as i, createElementBlock as a, createElementVNode as o, createTextVNode as te, createVNode as s, defineAsyncComponent as ne, defineComponent as c, mergeProps as l, normalizeClass as u, onBeforeMount as re, openBlock as d, ref as f, toDisplayString as p, unref as m, watch as ie, withCtx as h, withModifiers as g } from "vue";
import { PLACEHOLDER_UUID as _, quasarValidateRules as ae } from "@editor/ui-utils";
import { QBtn as oe, QCard as se, QCardSection as v, QDialog as ce, QIcon as y, QInput as le, QToggle as b, QTooltip as ue, useFormChild as de } from "quasar";
import { useI18n as fe } from "vue-i18n";
//#region src/components/editor-video-placeholder.vue
var x = {}, S = { class: "flex flex-center video-placeholder" };
function C(e, t) {
	return d(), a("div", S);
}
var w = /* @__PURE__ */ e(x, [["render", C], ["__scopeId", "data-v-a8802adc"]]), T = { class: "row justify-center items-center align-center text-center" }, E = { class: "col-6" }, D = {
	key: 0,
	class: "required"
}, O = { class: "video-container items-center" }, k = { class: "video-description" }, A = {
	key: 0,
	class: "text-primary"
}, j = {
	key: 1,
	"data-qa-article-video-title": ""
}, M = {
	key: 0,
	class: "video-toggle-controls"
}, N = { class: "spotted-container" }, P = { class: "spotted-child" }, F = { class: "spotted-child" }, I = { class: "tooltip-text" }, L = { key: 0 }, pe = { class: "q-field__messages text-negative col" }, R = ["textContent"], z = "video", B = /* @__PURE__ */ e(/* @__PURE__ */ c({
	__name: "video-list.selector",
	props: {
		isMain: {
			type: Boolean,
			default: !1
		},
		autoplay: {
			type: Boolean,
			default: void 0
		},
		isSpotted: {
			type: Boolean,
			default: !1
		},
		label: { default: void 0 },
		videoUuid: { default: "" },
		disable: {
			type: Boolean,
			default: !1
		},
		required: {
			type: Boolean,
			default: !1
		},
		square: {
			type: Boolean,
			default: !1
		},
		rules: { default: void 0 },
		license: { default: void 0 },
		status: { default: void 0 }
	},
	emits: [
		"update:video",
		"update:videoUuid",
		"update:autoplay",
		"update:isSpotted",
		"update:duration"
	],
	setup(e, { expose: c, emit: x }) {
		let S = ne(() => import("./video-list-D0J1xVXO.js")), C = e, B = x, V = f(""), H = f(!0), U = n({
			get: () => C.autoplay || !1,
			set: (e) => {
				B("update:autoplay", e);
			}
		}), W = n({
			get: () => C.isSpotted || !1,
			set: (e) => {
				B("update:isSpotted", e), B("update:autoplay", !e);
			}
		}), G = f({
			_id: void 0,
			title: "",
			videoRenditions: [],
			posterRenditions: [],
			posterImageUuid: "",
			state: void 0,
			publishStartDate: void 0,
			publishEndDate: void 0,
			license: [],
			legacy: {
				source: "vibe",
				isEditableInCTF: !1,
				isRenderedByCTF: !1,
				hasBeenModifiedInCTF: !1
			}
		}), K = f(!1), q = f(!1), J = f(), Y = () => {
			let e = ae(G.value, C.rules);
			H.value = !e, V.value = e;
		};
		de({
			validate() {
				return Y(), H.value || J.value?.scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "center"
				}), H.value;
			},
			resetValidation() {
				H.value = !0;
			}
		});
		let X = () => {
			C.disable || (q.value = !1, K.value = !0);
		};
		c({
			VideoData: G,
			showDialog: X
		});
		let Z = (e) => {
			q.value = !0, G.value = e, B("update:video", e), B("update:videoUuid", G.value._id), B("update:autoplay", !0), B("update:isSpotted", !1), B("update:duration", e.duration), K.value = !1;
		}, { t: Q } = fe(), me = n(() => C.label ? Q(C.label) : Q("videos.selectVideo")), $ = () => {
			G.value = {
				_id: void 0,
				title: "",
				videoRenditions: []
			}, Y(), B("update:video", void 0), B("update:videoUuid"), B("update:autoplay", void 0), B("update:isSpotted", void 0), B("update:duration", void 0), q.value = !1, K.value = !1;
		};
		return re(async () => {
			C.videoUuid && (G.value = await t(C.videoUuid));
		}), ie(() => C.videoUuid, async () => {
			C.videoUuid ? (G.value = await t(C.videoUuid), Y()) : G.value = {
				_id: void 0,
				title: ""
			};
		}, {
			deep: !0,
			immediate: !0
		}), (t, n) => (d(), a("div", {
			ref_key: "wrapper",
			ref: J
		}, [s(m(se), {
			flat: "",
			class: u({ invalid: !H.value })
		}, {
			default: h(() => [e.videoUuid ? (d(), r(m(v), {
				key: 1,
				style: { height: "100%" },
				class: "q-pa-none border-item"
			}, {
				default: h(() => [o("div", O, [G.value._id === m(_) ? (d(), r(w, {
					key: 1,
					class: "video-placeholder"
				})) : (d(), r(ee, {
					key: 0,
					"video-data": G.value,
					entity: z,
					square: e.square,
					size: "smallVideo",
					onClick: n[1] ||= g(() => {}, ["stop"])
				}, null, 8, ["video-data", "square"])), o("div", k, [o("div", null, [
					G.value.shortTitle ? (d(), a("div", A, p(G.value.shortTitle), 1)) : i("", !0),
					G.value.title ? (d(), a("p", j, p(G.value.title), 1)) : i("", !0),
					s(m(oe), {
						"data-qa-video-picker-remove-button": "",
						outline: "",
						color: "white",
						"text-color": "black",
						label: "Remove",
						class: "border-btn",
						disable: e.disable,
						onClick: $
					}, null, 8, ["disable"])
				]), e.isMain ? (d(), a("div", M, [o("div", N, [o("div", P, [s(m(b), {
					modelValue: W.value,
					"onUpdate:modelValue": n[2] ||= (e) => W.value = e,
					"data-qa-video-picker-is-spotted-toggle": "",
					label: m(Q)("articlesEdit.videoSpotted"),
					disable: e.disable
				}, null, 8, [
					"modelValue",
					"label",
					"disable"
				])]), o("div", F, [s(m(y), {
					name: "info",
					class: "q-mr-sm icon",
					color: "grey"
				}, {
					default: h(() => [s(m(ue), {
						"max-width": "350px",
						class: "bg-black text-body2",
						anchor: "top middle",
						self: "top middle",
						offset: [10, 40]
					}, {
						default: h(() => [o("div", I, p(m(Q)("articlesEdit.videoSpottedTooltip")), 1)]),
						_: 1
					})]),
					_: 1
				})])]), W.value ? i("", !0) : (d(), a("div", L, [s(m(b), {
					modelValue: U.value,
					"onUpdate:modelValue": n[3] ||= (e) => U.value = e,
					"data-qa-video-picker-autoplay-toggle": "",
					label: m(Q)("articlesEdit.videoAutoplay"),
					disable: e.disable
				}, null, 8, [
					"modelValue",
					"label",
					"disable"
				])]))])) : i("", !0)])])]),
				_: 1
			})) : (d(), r(m(v), {
				key: 0,
				style: { height: "100%" },
				"data-qa-video-picker": "",
				class: "custom-video-wrapper border-item border-item--dashed q-mt-md",
				onClick: X
			}, {
				default: h(() => [o("div", T, [o("div", E, [
					G.value.title ? i("", !0) : (d(), r(m(y), {
						key: 0,
						size: "36px",
						name: "video",
						color: "grey-5"
					})),
					s(m(le), l({
						modelValue: G.value.title,
						"onUpdate:modelValue": n[0] ||= (e) => G.value.title = e,
						"data-qa-video": "",
						class: "hidden",
						"append-icon": "external-link",
						clearable: "",
						readonly: "",
						borderless: ""
					}, t.$attrs, {
						"onClick:clear": Z,
						"onClick:append": X
					}), null, 16, ["modelValue"]),
					G.value.title ? i("", !0) : (d(), r(m(v), {
						key: 1,
						flat: "",
						class: "q-pa-sm",
						color: "white"
					}, {
						default: h(() => [te(p(me.value), 1), e.required ? (d(), a("span", D)) : i("", !0)]),
						_: 1
					}))
				])])]),
				_: 1
			})), V.value ? (d(), r(m(v), {
				key: 2,
				class: "q-field__bottom row items-start q-field__bottom--animated"
			}, {
				default: h(() => [o("div", pe, [o("div", {
					role: "alert",
					textContent: p(V.value)
				}, null, 8, R)])]),
				_: 1
			})) : i("", !0)]),
			_: 1
		}, 8, ["class"]), s(m(ce), {
			modelValue: K.value,
			"onUpdate:modelValue": n[6] ||= (e) => K.value = e,
			"data-qa-video-modal": "",
			"full-width": "",
			"full-height": "",
			onHide: n[7] ||= (e) => K.value = !1
		}, {
			default: h(() => [q.value ? i("", !0) : (d(), r(m(S), {
				key: 0,
				dialog: !0,
				license: e.license,
				status: e.status,
				"onNew:clicked": n[4] ||= (e) => q.value = !0,
				onClose: $,
				"onClick:video": Z,
				"onBack:modal": n[5] ||= (e) => K.value = !1
			}, null, 8, ["license", "status"]))]),
			_: 1
		}, 8, ["modelValue"])], 512));
	}
}), [["__scopeId", "data-v-671e38db"]]);
//#endregion
export { B as t };

//# sourceMappingURL=video-list.selector-IYnAVA2t.js.map